module.exports = "mutation saveAttachments($adviceRequestId:String!,$files:[FileInput!]!){saveAttachments(adviceRequestId:$adviceRequestId,files:$files)}"